import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { Dashboard } from './pages/dashboard/dashboard';
import { Admin } from './pages/admin/admin';
import { adminGuard } from './guards/admin-guard';

export const routes: Routes = [
  { path: '', component: Dashboard, canActivate: [MsalGuard] },
  { path: 'dashboard', component: Dashboard, canActivate: [MsalGuard] },
  { path: 'admin', component: Admin, canActivate: [MsalGuard, adminGuard] },
  { path: '**', redirectTo: '' }
];
